/**
 * 实名流程接口
 */
import { Method } from '../core';
import { API, SOURCE } from '../config';

const api = API;

export default {
  // 多次打款
  payAgain: {
    url: `${api}/rest/v1/realname/organ/payAgain`,
    method: Method.POST,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 多次打款
  updateStatus: {
    url: `${api}/rest/v1/realname/organ/update2UnRealname`,
    method: Method.POST,
    body: {
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/resource-api/api/realName.js